module.exports = __webpack_public_path__ + "front/img/bmbg01.35f9acfb.png";